<router-outlet></router-outlet>
<app-bs-modal ></app-bs-modal>
<app-app-loader></app-app-loader>
<app-bootstrap-modal modalId="userResetPasswordModal">
    <app-user-reset-password></app-user-reset-password>
</app-bootstrap-modal>

